module.exports = __webpack_public_path__ + "static/map_usa_NE-16ff62a339c94fb8eeba8d5781088b47.png";